import { defineComponent } from 'vue-demi'
import { connect, h, mapProps, mapReadPretty } from '@formily/vue'
import FormCopy from './Layout'
/* eslint-disable vue/require-default-prop, vue/require-prop-types */
const FormilyCopy = defineComponent({
  name: 'Copy',
  props: {
    value: {},
  },
  setup(props, { attrs, slots, listeners, emit }) {
    return () => {
      return h(
        FormCopy,
        {
          attrs: {
            ...attrs,
          },
          props: {
            ...props,
          },
          on: {
            ...listeners,
          },
        },
        {
          default: () => {
            return props.value
          },
        },
      )
    }
  },
})

const Copy = connect(
  FormilyCopy,
  mapProps({ readOnly: 'readonly' }),
  mapReadPretty(FormilyCopy, { disabled: true }),
)

export default Copy
